import TicketTypeIcon from "app/components/TicketTypeIcon";
import CustomTooltip from "app/components/Tooltip";
import CommonTicketTypeSelection from "app/containers/Features/components/CommonTicketTypeSelection";
import { ITicketTypes } from "app/containers/Features/containers/TeamSettings/container/Projects/container/WorkItems/types";
import React, { FC, useMemo } from "react";
import { getTicketTypeByIds } from "../../../TeamSettings/container/Projects/container/WorkItems/helper";

interface TicketTypeButtonProps {
  readonly type: string;
  readonly setValue: (val: string) => void;
  readonly ticketTypes: ITicketTypes[];
  onOpen: () => void;
  onClose: () => void;
}

export const TicketTypeButton: FC<TicketTypeButtonProps> = ({
  type,
  setValue,
  ticketTypes,
  onOpen,
  onClose,
}) => {
  const ticketType = useMemo(() => {
    return getTicketTypeByIds(ticketTypes, type)[0];
  }, [ticketTypes, type]);
  const updateValue = (data: ITicketTypes) => {
    setValue(data._id);
  };
  return (
    <CommonTicketTypeSelection
      trigger={
        <button className="flex flex-row items-center gap-[4px] h-[28px] px-[6px] capitalize rounded-[4px] border border-[#E9ECF2] text-xs leading-[18px] font-medium text-secondary hover:bg-[#ECEEF2]  hover:border-[#E9ECF2] rounded-[4px] data-[state=open]:border-[#79808A] data-[state=open]:outline-[#79808A] data-[state=open]:border-[1px] min-w-max">
          <CustomTooltip text="Set ticket type" position="bottom">
            <div className="flex items-center gap-1 w-full">
              <TicketTypeIcon
                iconName={ticketType?.icon as string}
                size={16}
              />

              <span className="text-sm">{ticketType?.name}</span>
            </div>
          </CustomTooltip>
        </button>
      }
      className="min-w-[237px]"
      align="start"
      showEndIcon
      showDefault
      isHeader="Ticket Types"
      value={type}
      isUnPaddedY={true}
      setValue={updateValue}
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};
